<template>
  <div name="navbar">
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#">
            <i class="fas fa-bars"></i>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a
            class="nav-link"
            data-widget="control-sidebar"
            data-slide="true"
            href="#"
          >
            <img
              :src="getimage"
              class="user-image img-circle"
              title="Username"
              alt="User Image"
            />
            <!-- <el-avatar  src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar> -->
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "navbar",
  data() {
    return {
      image: "https://api.soonnet.org/Userlogo_Smail.jpg",
      user: null,
    };
  },
  created() {
    this.user = this.$store.getters.getUser;
    if (this.user != null && this.user != "") {
      this.image =
        "https://api.soonnet.org/Account/Acc_Resources/" +
        this.user.userId +
        "/Userlogo_Smail.jpg";
    }
  },
  methods: {},
  computed: {
    getimage() {
      return this.image;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminManage/navbar.vue